import React from 'react';
import Header from './header';
import Footer from './footer';
import { Outlet } from 'react-router';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';

import '../../assets/user/css/icofont.min.css';
import '../../assets/user/css/animate.css';
import '../../assets/user/css/style.min.css';

const WebLayout = () => {
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  );
};

export default WebLayout;
